import {
  WSCard,
  WSFlexBox,
  WSIcon,
  WSList,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { IFormChecklistItem } from "../types";

type Props = {
  item: IFormChecklistItem;
  /** The full checklist, for resolving a blocking id to its title. */
  allItems: IFormChecklistItem[];
};

export const ChecklistLockedItem: React.FC<Props> = ({ item, allItems }) => {
  const blockingTitle = allItems.find(
    otherItem => otherItem.id === item.blockedBy[0]
  )?.title;

  return (
    <WSCard>
      <WSFlexBox.CenterY justify="space-between" wrap="wrap" gap="M">
        <WSList gap="XS">
          <WSFlexBox.CenterY gap="S">
            <WSIcon name="lock" color="gray500" size="S" />
            <WSText.Paragraph weight="medium" color="gray500">
              {item.title}
            </WSText.Paragraph>
            <WSPill theme="neutral" text="Locked" />
          </WSFlexBox.CenterY>
          {blockingTitle ? (
            <WSText.ParagraphSm color="gray500">
              Complete {blockingTitle} to unlock this form.
            </WSText.ParagraphSm>
          ) : null}
        </WSList>
      </WSFlexBox.CenterY>
    </WSCard>
  );
};
